<template>
  <div class="container">
    <v-progress-circular
        v-if="loading"
        :size="200"
        :width="10"
        color="primary"
        indeterminate>
      <span class="loading-text">{{ loadingText }}</span>
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "Blank",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'loading...'
    }
  },
}
</script>

<style scoped>
.container {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.loading-text {
  font-size: 1rem;
  font-family: sans-serif;
}
</style>
